define('drops/buttonWithIcon/buttonWithIcon',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/tooltip',
    'lq/onlongpress'
], function ($, lq, Drop, Style, util, Tooltip, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            icon: '?',
            iconType: 'font',
            text: 'New Button with Icon',
            title: {
                option: Tooltip.hardcoded
            },
            useDynamicWidth: true,
            useDynamicHeight: true,
            longPressDelay: 1000,
            activeStyleDuration: 0
        }
    };

    function ButtonWithIcon(options) {
        var self = this;

        Drop.call(this, $('<div/>'), defaults, options);

        this.defaultStyleSettings = {
            text: { verticalAlign: 'middle' }
        };

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.$icon = $('<span class="buttonIcon drop-text-content"></span>');
        this.renderIcon();

        this.$text = $('<span class="text drop-text-content">' + this.data.text + '</span>');

        this.$button = $('<div/>')
            .addClass('boxToBorderSize drop-text-content iconTextWrapper')
            .attr('name', this.data.name)
            .append(this.$icon)
            .append(this.$text)
            .attr('tabindex', this.data.tabIndex)
            .css({
                display: 'flex',
                flex: '1 1 100%',
                width: '100%'
            });

        // WHY setting 'display: table' on $element would break centered anchoring, so we have to add a wrapper
        this.$element
            .append($('<div />')
                .css({
                    cursor: 'pointer',
                    display: 'flex',
                    whiteSpace: 'pre-wrap',
                    height: '100%',
                    width: '100%'
                })
                .append(this.$button));

        new OnLongPress().applyLongPressOnElement(this.$button, this);
        if (this.data.eventing && this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            var self = this;
            this.$element
                .on('keypress', function (e) {
                    if (e.keyCode === 13) {
                        self.triggerEvent(self.data.eventing.clicked.raisedEventName);
                    }
	            });
        }

        if (this.data.activeStyleDuration > 0) {
            this.$element
                .on('click', this.triggerActiveStyle.bind(this));
        }

        this.applyEventTrigger('mouseEnter', 'mouseenter');
        this.applyEventTrigger('mouseLeave', 'mouseleave');
        this.addEventsToBeCanceledAndCanceledBy('mouseEnter', 'mouseLeave');

        this.tooltip = new Tooltip(this, this.data.title, this.$element);
    };

    Drop.extend(ButtonWithIcon);

    ButtonWithIcon.typeName = 'ButtonWithIcon';

    function isSvg(path) {
        if (!path || typeof path !== 'string') {
            return false;
        }
        return /\.svg($|\?)/i.test(path);
    }

    ButtonWithIcon.prototype.isSvg = isSvg;

    ButtonWithIcon.prototype.renderIcon = function () {
        var self = this;
        this.$icon.empty();

        if (this.data.iconType === 'image' && this.data.image) {
            var image = this.data.image;
            var url = lq.getTenantUploads(image);

            $('<img />')
                .attr('src', url)
                .appendTo(this.$icon);

            if (this.isSvg(image)) {
                $.get(url, function (data) {
                    if (self.data.image !== image) return;

                    var doc = new DOMParser().parseFromString(data, 'image/svg+xml');
                    var svgElement = doc.querySelector('svg');
                    if (svgElement && !doc.querySelector('parsererror')) {
                        if (!svgElement.getAttribute('viewBox') && svgElement.getAttribute('width') && svgElement.getAttribute('height')) {
                            var w = parseFloat(svgElement.getAttribute('width'));
                            var h = parseFloat(svgElement.getAttribute('height'));
                            if (!isNaN(w) && !isNaN(h) && w > 0 && h > 0) {
                                svgElement.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
                            }
                        }
                        self.$icon.empty().append(document.importNode(svgElement, true));
                    }
                }, 'text');
            }

            this.$icon.css({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            });
        } else {
            this.$icon.text(this.data.icon || '');
        }
    };

    ButtonWithIcon.prototype.triggerActiveStyle = function () {
        this.$button.addClass('active');

        var self = this;
        setTimeout(function () {
            self.$button.removeClass('active');
        }, this.data.activeStyleDuration);
    };

    ButtonWithIcon.prototype.renderStyles = function () {
        Style.renderStyles(this, null, this.$button);

        // WHY: the text-stylings of the main element should affect $text sub-element, but not $icon
        this.moveAttributeToTextElement('font-style', 'normal');
        this.moveAttributeToTextElement('text-decoration', 'none');
        this.moveAttributeToTextElement('text-transform', 'none');
    };

    ButtonWithIcon.prototype.preRender = function () {
        this.renderIcon();
        this.tooltip.update();

        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    ButtonWithIcon.prototype.postRender = function () {
        this.renderStyles();
    };

    ButtonWithIcon.prototype.moveAttributeToTextElement = function (attributeName, parentReplacement) {
        this.$text.css(attributeName, this.$button.css(attributeName));
        this.$button.css(attributeName, parentReplacement);
    };

    return ButtonWithIcon;
});
